import React, { useState, useEffect } from 'react';
import { analyticsAPI } from '../services/api';
import './Analytics.css';

function Analytics() {
  const [overview, setOverview] = useState(null);
  const [popular, setPopular] = useState([]);
  const [trending, setTrending] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAnalytics();
  }, []);

  const loadAnalytics = async () => {
    try {
      setLoading(true);
      const [overviewRes, popularRes, trendingRes, categoriesRes] = await Promise.all([
        analyticsAPI.getOverview(),
        analyticsAPI.getPopular(),
        analyticsAPI.getTrending(),
        analyticsAPI.getCategories(),
      ]);
      setOverview(overviewRes.data);
      setPopular(popularRes.data || []);
      setTrending(trendingRes.data || []);
      setCategories(categoriesRes.data || []);
    } catch (err) {
      console.error('Failed to load analytics:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading analytics...</div>;
  }

  return (
    <div className="analytics">
      <h2>Analytics Dashboard</h2>
      
      {overview && (
        <div className="analytics-section">
          <h3>Overview</h3>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-value">{overview.total_prompts || 0}</div>
              <div className="stat-label">Total Prompts</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{overview.total_likes || 0}</div>
              <div className="stat-label">Total Likes</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{overview.total_views || 0}</div>
              <div className="stat-label">Total Views</div>
            </div>
          </div>
        </div>
      )}

      {popular.length > 0 && (
        <div className="analytics-section">
          <h3>Most Popular</h3>
          <div className="prompt-list">
            {popular.map(prompt => (
              <div key={prompt.id} className="prompt-item">
                <strong>{prompt.title}</strong> - {prompt.likes || 0} likes
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Analytics;
